import Vue from "vue";

function formatearImporteCeca(importe) {
  if (importe === null || importe === undefined || importe === "") {
    return "0";
  }

  if (typeof importe === "number") {
    return String(Math.round(importe * 100));
  }

  const importeNormalizado = String(importe).trim().replace(/\s/g, "");
  const ultimoPunto = importeNormalizado.lastIndexOf(".");
  const ultimaComa = importeNormalizado.lastIndexOf(",");

  let separadorDecimal = "";

  if (ultimoPunto !== -1 && ultimaComa !== -1) {
    separadorDecimal = ultimoPunto > ultimaComa ? "." : ",";
  } else {
    const ultimaPosicionSeparador = Math.max(ultimoPunto, ultimaComa);
    const digitosDecimales =
      ultimaPosicionSeparador === -1
        ? 0
        : importeNormalizado.length - ultimaPosicionSeparador - 1;

    if (digitosDecimales > 0 && digitosDecimales <= 2) {
      separadorDecimal = ultimoPunto !== -1 ? "." : ",";
    }
  }

  let importeSinMiles = importeNormalizado;

  if (separadorDecimal) {
    const separadorMiles = separadorDecimal === "." ? "," : ".";
    importeSinMiles = importeSinMiles.replace(
      new RegExp("\\" + separadorMiles, "g"),
      ""
    );
    importeSinMiles = importeSinMiles.replace(separadorDecimal, ".");
  } else {
    importeSinMiles = importeSinMiles.replace(/[.,]/g, "");
  }

  const importeNumero = Number(importeSinMiles);

  if (Number.isNaN(importeNumero)) {
    return "0";
  }

  return String(Math.round(importeNumero * 100));
}

export async function getReservasCalendario(
  context,
  [access_token, from, until, loading]
) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas_calendario",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: {
          from,
          until,
        },
      });
      context.commit("reservas/setReservasCalendario", response.data, {
        root: true,
      });
    }
  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function getReservas(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
    }
  } catch (e) {
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function getReserva(context, [access_token, id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas/" + id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      } else {
        return null;
      }
    }
  } catch (e) {
  } finally {
  }
}

export async function getDisponibilidadAnual(context, [access_token, year]) {
  try {
    if (access_token) {
      context.commit("setLoading", true, { root: true });
      const response = await Vue.axios({
        method: "GET",
        url: "/info_anual?year=" + year.toString(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      context.commit("reservas/setDisponibilidadAnual", response.data, {
        root: true,
      });
    }
  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function crearReserva(context, [access_token, modelReserva]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/reservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          modelReserva,
        },
      });
      if (
        response &&
        response.status == 201 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function updateReserva(context, [access_token, modelReserva]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/update_reserva",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          modelReserva,
        },
      });

      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function asignarNumeroFactura(
  context,
  [access_token, reserva_id, factura]
) {
  try {
    if (access_token) {
      const data = {
        reserva_id,
      };

      if (factura !== undefined && factura !== null && String(factura).trim() !== "") {
        data.factura = String(factura).trim();
      }

      const response = await Vue.axios({
        method: "POST",
        url: "/asignar_numero_factura",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data,
      });
      if (response && response.status == 201 && response.data) {
        return response.data.factura;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function eliminarReserva(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "DELETE",
        url: "/reservas/" + reserva_id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (response.status == 200) {
        // context.commit('reservas/actDeleteListReservas', reserva_id, { root: true })
      }
      return response;
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function verificarSolapamiento(context, [access_token, reserva_id]) {
  try {
    if (access_token) {

      const response = await Vue.axios({
        method: "GET",
        url: "/reservas/solapamiento/" + reserva_id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });

      if (response.status == 200) {
        console.log("responseSolapamiento", response);
        return response.data.solapamiento;
      }
      return false;
    }
  } catch (e) {
  } finally {

  }
}


export async function obtenerUrlPago(context, [access_token, reserva_id, codigo, importe]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/obtenerUrlPago?reserva_id=" + reserva_id + "&codigo=" + codigo + "&importe=" + importe,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      console.log('response:', response.data);
      if (
        response &&
        response.status == 200 &&
        response.data

      ) {
        return response.data;
      } else {
        return null;
      }
    }

  } catch (e) {
  } finally {

  }
}

export async function obtenerUrlPagoCeca(context, [access_token, reserva_id, codigo, importe]) {
  try {
    if (access_token) {
      const importeFormateado = formatearImporteCeca(importe);
      const response = await Vue.axios({
        method: "POST",
        url: "/ceca/payment-links",
        data: {
          reserva_id: reserva_id,
          order_num: codigo,
          importe: importeFormateado,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });

      console.log("response:", response.data);

      if (
        response &&
        response.status == 201 &&
        response.data
      ) {
        return response.data;
      } else {
        return null;
      }
    }
  } catch (e) {
    console.error(e);
    return null;
  } finally {
  }
}

export async function updateUrlPago(context, [access_token, reserva_id, url_pago]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/updateUrlPago",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
          url_pago
        },
      });
      console.log('response:', response.data);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.reserva

      ) {
        console.log('response.data.reserva:', response.data.reserva);
        context.commit("reservas/actUrlPagoListReservas", response.data.reserva, { root: true });
        return response.data;
      } else {
        return null;
      }
    }

  } catch (e) {
  } finally {

  }
}
